// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ap-Navbar-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 70px;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1000;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 1rem;
    background: black;
    box-shadow: 0px 1px darkslategray;
  }
  
  /* Left Segment - 20% */
  .navbar-left-segment {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 10px;
    min-width: fit-content;
  }
  
  .navbar-app-logo-container {
    cursor: pointer;
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .app-logo {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: cover;
  }
  
  /* Right Segment - 80% */
  .navbar-right-segment {
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 20px;
  }
  
  .navbar-action-buttons {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  .navbar-icon-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s;
  }
  
  .navbar-icon-btn:hover {
    transform: scale(1.1);
  }
  
  .navbar-products {
    display: flex;
    align-items: center;
  }
  
  /* Three-bar Menu Icon */
  .navbar-menu-icon {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 24px;
    padding: 5px;
    transition: transform 0.2s;
  }
  
  .navbar-menu-icon:hover {
    transform: scale(1.1);
  }
  
  .menu-bar {
    width: 100%;
    height: 3px;
    background-color: white;
    border-radius: 2px;
    transition: all 0.3s ease;
  }
  
  .navbar-menu-icon:hover .menu-bar {
    background-color: #4CAF50;
  }
  
  /* Main Menu Popup */
  .navbar-menu-popup {
    position: absolute;
    top: 70px;
    right: 20px;
    width: 200px;
    background: #1a1a1a;
    border: 1px solid darkslategray;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    z-index: 9999;
    overflow: hidden;
  }
  
  .menu-popup-item {
    padding: 12px 20px;
    color: white;
    cursor: pointer;
    transition: background 0.2s;
    border-bottom: 1px solid rgba(47, 79, 79, 0.3);
  }
  
  .menu-popup-item:last-child {
    border-bottom: none;
  }
  
  .menu-popup-item:hover {
    background: #2a2a2a;
    color: #4CAF50;
  }
  
  /* Options Sub-Popup */
  .navbar-options-popup {
    position: absolute;
    top: 70px;
    right: 230px;
    width: 200px;
    background: #1a1a1a;
    border: 1px solid darkslategray;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    z-index: 10000;
    overflow: hidden;
  }
  
  .menu-logout {
    color: #ff4444;
    font-weight: bold;
  }
  
  .menu-logout:hover {
    background: #ff4444;
    color: white;
  }
  
  /* Search Dropdown */
  .nb-search-dropdown {
    position: absolute;
    top: 70px;
    right: 150px;
    width: 400px;
    max-width: calc(100vw - 40px);
    background: black;
    border: 1px solid #252424;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .search-dropdown input {
    width: 100%;
    padding: 8px;
    margin-bottom: 10px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }
  
  /* Tooltip */
  .tooltip {
    visibility: hidden;
    width: 150px;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px;
    border-radius: 5px;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  /* Mobile Responsiveness */
  @media (max-width: 768px) {
    .navbar-left-segment {
      width: 25%;
    }
  
    .navbar-right-segment {
      width: 75%;
    }
  
    .navbar-action-buttons {
      gap: 8px;
    }
  
    .navbar-app-logo-container {
      height: 40px;
      width: 40px;
    }
  
    .navbar-menu-icon {
      width: 25px;
      height: 20px;
    }
  
    .navbar-menu-popup,
    .navbar-options-popup {
      width: 180px;
    }
  
    .nb-search-dropdown {
      width: 90vw;
      right: 5vw;
    }
  }
  
  @media (max-width: 480px) {
    .navbar-left-segment {
      width: 30%;
    }
  
    .navbar-right-segment {
      width: 70%;
    }
  
    .navbar-action-buttons {
      gap: 5px;
    }
  
    .menu-popup-item {
      padding: 10px 15px;
      font-size: 14px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/common/Navbar/NavbarMob.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mJAAmJ;IACnJ,eAAe;IACf,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA,uBAAuB;EACvB;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA,wBAAwB;EACxB;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,sBAAsB;EACtB;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,yCAAyC;IACzC,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,YAAY;EACZ;IACE,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,6BAA6B;EAC/B;;EAEA,0BAA0B;EAC1B;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,YAAY;MACZ,WAAW;IACb;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;;MAEE,YAAY;IACd;;IAEA;MACE,WAAW;MACX,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF","sourcesContent":[".ap-Navbar-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 70px;\n    color: white;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 1000;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    font-size: 1rem;\n    background: black;\n    box-shadow: 0px 1px darkslategray;\n  }\n  \n  /* Left Segment - 20% */\n  .navbar-left-segment {\n    width: 20%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding-left: 10px;\n    min-width: fit-content;\n  }\n  \n  .navbar-app-logo-container {\n    cursor: pointer;\n    height: 50px;\n    width: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .app-logo {\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    object-fit: cover;\n  }\n  \n  /* Right Segment - 80% */\n  .navbar-right-segment {\n    width: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding-right: 20px;\n  }\n  \n  .navbar-action-buttons {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n  }\n  \n  .navbar-icon-btn {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: transform 0.2s;\n  }\n  \n  .navbar-icon-btn:hover {\n    transform: scale(1.1);\n  }\n  \n  .navbar-products {\n    display: flex;\n    align-items: center;\n  }\n  \n  /* Three-bar Menu Icon */\n  .navbar-menu-icon {\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 30px;\n    height: 24px;\n    padding: 5px;\n    transition: transform 0.2s;\n  }\n  \n  .navbar-menu-icon:hover {\n    transform: scale(1.1);\n  }\n  \n  .menu-bar {\n    width: 100%;\n    height: 3px;\n    background-color: white;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n  }\n  \n  .navbar-menu-icon:hover .menu-bar {\n    background-color: #4CAF50;\n  }\n  \n  /* Main Menu Popup */\n  .navbar-menu-popup {\n    position: absolute;\n    top: 70px;\n    right: 20px;\n    width: 200px;\n    background: #1a1a1a;\n    border: 1px solid darkslategray;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n    z-index: 9999;\n    overflow: hidden;\n  }\n  \n  .menu-popup-item {\n    padding: 12px 20px;\n    color: white;\n    cursor: pointer;\n    transition: background 0.2s;\n    border-bottom: 1px solid rgba(47, 79, 79, 0.3);\n  }\n  \n  .menu-popup-item:last-child {\n    border-bottom: none;\n  }\n  \n  .menu-popup-item:hover {\n    background: #2a2a2a;\n    color: #4CAF50;\n  }\n  \n  /* Options Sub-Popup */\n  .navbar-options-popup {\n    position: absolute;\n    top: 70px;\n    right: 230px;\n    width: 200px;\n    background: #1a1a1a;\n    border: 1px solid darkslategray;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n    z-index: 10000;\n    overflow: hidden;\n  }\n  \n  .menu-logout {\n    color: #ff4444;\n    font-weight: bold;\n  }\n  \n  .menu-logout:hover {\n    background: #ff4444;\n    color: white;\n  }\n  \n  /* Search Dropdown */\n  .nb-search-dropdown {\n    position: absolute;\n    top: 70px;\n    right: 150px;\n    width: 400px;\n    max-width: calc(100vw - 40px);\n    background: black;\n    border: 1px solid #252424;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n    z-index: 9999;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .search-dropdown input {\n    width: 100%;\n    padding: 8px;\n    margin-bottom: 10px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n  }\n  \n  /* Tooltip */\n  .tooltip {\n    visibility: hidden;\n    width: 150px;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    padding: 5px;\n    border-radius: 5px;\n    position: absolute;\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n  }\n  \n  /* Mobile Responsiveness */\n  @media (max-width: 768px) {\n    .navbar-left-segment {\n      width: 25%;\n    }\n  \n    .navbar-right-segment {\n      width: 75%;\n    }\n  \n    .navbar-action-buttons {\n      gap: 8px;\n    }\n  \n    .navbar-app-logo-container {\n      height: 40px;\n      width: 40px;\n    }\n  \n    .navbar-menu-icon {\n      width: 25px;\n      height: 20px;\n    }\n  \n    .navbar-menu-popup,\n    .navbar-options-popup {\n      width: 180px;\n    }\n  \n    .nb-search-dropdown {\n      width: 90vw;\n      right: 5vw;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .navbar-left-segment {\n      width: 30%;\n    }\n  \n    .navbar-right-segment {\n      width: 70%;\n    }\n  \n    .navbar-action-buttons {\n      gap: 5px;\n    }\n  \n    .menu-popup-item {\n      padding: 10px 15px;\n      font-size: 14px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
